import { getRestaurantId } from "@/config/restaurant-id";

/** In-memory cache for the browser tab session (survives route changes until reload). */
export const RESTAURANT_CONFIG_SESSION_TTL_MS = 24 * 60 * 60 * 1000;

/**
 * Cache key still includes bootstrap RestaurantId for tenant segmentation.
 * HTTP config fetch uses public/v1/storefront/r/{slug}/restaurant (no RestaurantId on the wire).
 */
export function restaurantConfigQueryKey(restaurantId: string = getRestaurantId()): string {
  return `restaurant|config|v1|rid:${restaurantId.trim()}`;
}
